import React, { useEffect, useState } from "react";
import "./Billing.css";
import { db } from "../../firebase-config";
import { Link } from "react-router-dom";
import { ref, onValue } from "firebase/database";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Billing() {
  // Initialize posts as an object to match the data structure from firebase
  const [posts, setPosts] = useState({});
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const postsRef = ref(db, `superadmin/admins`);
    onValue(postsRef, (snapshot) => {
      const data = snapshot.val();
      setPosts(data || {});
    });
  }, []);

  // Handle search input changes
  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  // Filter the posts based on the search query (case-insensitive)
  const filteredIds =
    posts &&
    Object.keys(posts).filter((id) => {
      const fullName = posts[id]?.FullName || "";
      return fullName.toLowerCase().includes(searchQuery.toLowerCase());
    });

  return (
    <>
      <div className="container-fluid">
        <h2 className="text-center adminlist">Billing</h2>
        <Link to="/SuperAdmin" className="homeButton">
          <span id="backText" className="backText">
            Back
          </span>
          <i
            id="backIcon"
            className="fas fa-long-arrow-alt-left fa-lg fa-2x"
          ></i>
        </Link>
        {/* Centered Search Bar */}
        <div style={{ textAlign: "center", margin: "1px 0" }}>
          <input
            type="text"
            placeholder="Search admin by name"
            value={searchQuery}
            onChange={handleSearch}
            style={{ padding: "8px", width: "300px", margin: "0 auto" }}
          />
        </div>
        <div style={{ marginTop: "50px", textAlign: "center" }}>
          <table
            className="styled-table ViewAllAdminPageTable"
            style={{ margin: "0 auto", width: "80%" }}
          >
            <thead>
              <tr>
                <th className="th-head" style={{ textAlign: "center" }}>
                  No.
                </th>
                <th className="th-head" style={{ textAlign: "center" }}>
                  Name
                </th>
                {/* <th className="th-head" style={{ textAlign: "center" }}>
                  License Expire in
                </th> */}
                <th className="th-head" style={{ textAlign: "center" }}>
                  Detail
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredIds && filteredIds.length > 0 ? (
                filteredIds.map((id, index) => {
                  return (
                    <tr key={index}>
                      <th scope="row">{index + 1}</th>
                      <td className="admin-name">{posts[id]?.FullName}</td>
                      <td>
                        <div className="link-buttons">
                          <Link to={"/SuperAdmin/BillingDetails" + id}>
                            <button className="btn btn-view">
                              View Billing Details
                            </button>
                          </Link>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="3" style={{ textAlign: "center" }}>
                    No matching admin found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Link to={"/SuperAdmin"}>
        <div className="container text-center mt-4">
          <button className="backbutton1">Back</button>
        </div>
      </Link>
      <ToastContainer />
    </>
  );
}

export default Billing;
